import React from 'react'

const Legend = (props) => {
    const legendTypes  = props.legendType;
    return (
        <div className="map-legends legendbox-right">

            <label className="mapcheckboxhead" > Legend </label>
            {legendTypes && legendTypes.map((type, index) => (
                <div key={index} className="set-miles">
                    <span style={{ height: '10px', width: '10px', backgroundColor: type.color, borderRadius: '50%', display: 'inline-block', marginRight: '5px'}}  ></span> {type.label}
                </div>
            ))} 

        </div>
    )
}

export default Legend